/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetLabelsParams,
  GetLabelsSuggestParams,
  LabelDto,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All
 */
export const getLabels = (params?: GetLabelsParams, signal?: AbortSignal) => {
  return customInstance<LabelDto[]>({
    url: `/labels`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetLabelsInfiniteQueryKey = (params?: GetLabelsParams) => {
  return ["infinite", `/labels`, ...(params ? [params] : [])] as const;
};

export const getGetLabelsQueryKey = (params?: GetLabelsParams) => {
  return [`/labels`, ...(params ? [params] : [])] as const;
};

export const getGetLabelsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getLabels>>>,
  TError = void,
>(
  params?: GetLabelsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabels>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLabelsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabels>>> = ({
    signal,
  }) => getLabels(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getLabels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabelsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLabels>>
>;
export type GetLabelsInfiniteQueryError = void;

export function useGetLabelsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabels>>>,
  TError = void,
>(
  params: undefined | GetLabelsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabels>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabels>>,
          TError,
          Awaited<ReturnType<typeof getLabels>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabels>>>,
  TError = void,
>(
  params?: GetLabelsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabels>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabels>>,
          TError,
          Awaited<ReturnType<typeof getLabels>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabels>>>,
  TError = void,
>(
  params?: GetLabelsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabels>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetLabelsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabels>>>,
  TError = void,
>(
  params?: GetLabelsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabels>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLabelsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetLabelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabels>>,
  TError = void,
>(
  params?: GetLabelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabels>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabelsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabels>>> = ({
    signal,
  }) => getLabels(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLabels>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetLabelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLabels>>
>;
export type GetLabelsQueryError = void;

export function useGetLabels<
  TData = Awaited<ReturnType<typeof getLabels>>,
  TError = void,
>(
  params: undefined | GetLabelsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabels>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabels>>,
          TError,
          Awaited<ReturnType<typeof getLabels>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabels<
  TData = Awaited<ReturnType<typeof getLabels>>,
  TError = void,
>(
  params?: GetLabelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabels>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabels>>,
          TError,
          Awaited<ReturnType<typeof getLabels>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabels<
  TData = Awaited<ReturnType<typeof getLabels>>,
  TError = void,
>(
  params?: GetLabelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabels>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetLabels<
  TData = Awaited<ReturnType<typeof getLabels>>,
  TError = void,
>(
  params?: GetLabelsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabels>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLabelsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postLabels = (labelDto: LabelDto, signal?: AbortSignal) => {
  return customInstance<LabelDto>({
    url: `/labels`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: labelDto,
    signal,
  });
};

export const getPostLabelsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postLabels>>,
    TError,
    { data: LabelDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postLabels>>,
  TError,
  { data: LabelDto },
  TContext
> => {
  const mutationKey = ["postLabels"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postLabels>>,
    { data: LabelDto }
  > = (props) => {
    const { data } = props ?? {};

    return postLabels(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostLabelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postLabels>>
>;
export type PostLabelsMutationBody = LabelDto;
export type PostLabelsMutationError = void;

/**
 * @summary Create
 */
export const usePostLabels = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postLabels>>,
      TError,
      { data: LabelDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postLabels>>,
  TError,
  { data: LabelDto },
  TContext
> => {
  const mutationOptions = getPostLabelsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Suggest
 */
export const getLabelsSuggest = (
  params?: GetLabelsSuggestParams,
  signal?: AbortSignal,
) => {
  return customInstance<LabelDto[]>({
    url: `/labels/suggest`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetLabelsSuggestInfiniteQueryKey = (
  params?: GetLabelsSuggestParams,
) => {
  return ["infinite", `/labels/suggest`, ...(params ? [params] : [])] as const;
};

export const getGetLabelsSuggestQueryKey = (
  params?: GetLabelsSuggestParams,
) => {
  return [`/labels/suggest`, ...(params ? [params] : [])] as const;
};

export const getGetLabelsSuggestInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsSuggest>>>,
  TError = void,
>(
  params?: GetLabelsSuggestParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLabelsSuggestInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLabelsSuggest>>
  > = ({ signal }) => getLabelsSuggest(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getLabelsSuggest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabelsSuggestInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLabelsSuggest>>
>;
export type GetLabelsSuggestInfiniteQueryError = void;

export function useGetLabelsSuggestInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsSuggest>>>,
  TError = void,
>(
  params: undefined | GetLabelsSuggestParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelsSuggest>>,
          TError,
          Awaited<ReturnType<typeof getLabelsSuggest>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsSuggestInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsSuggest>>>,
  TError = void,
>(
  params?: GetLabelsSuggestParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelsSuggest>>,
          TError,
          Awaited<ReturnType<typeof getLabelsSuggest>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsSuggestInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsSuggest>>>,
  TError = void,
>(
  params?: GetLabelsSuggestParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Suggest
 */

export function useGetLabelsSuggestInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsSuggest>>>,
  TError = void,
>(
  params?: GetLabelsSuggestParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLabelsSuggestInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetLabelsSuggestQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabelsSuggest>>,
  TError = void,
>(
  params?: GetLabelsSuggestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLabelsSuggestQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLabelsSuggest>>
  > = ({ signal }) => getLabelsSuggest(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLabelsSuggest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabelsSuggestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLabelsSuggest>>
>;
export type GetLabelsSuggestQueryError = void;

export function useGetLabelsSuggest<
  TData = Awaited<ReturnType<typeof getLabelsSuggest>>,
  TError = void,
>(
  params: undefined | GetLabelsSuggestParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelsSuggest>>,
          TError,
          Awaited<ReturnType<typeof getLabelsSuggest>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsSuggest<
  TData = Awaited<ReturnType<typeof getLabelsSuggest>>,
  TError = void,
>(
  params?: GetLabelsSuggestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelsSuggest>>,
          TError,
          Awaited<ReturnType<typeof getLabelsSuggest>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsSuggest<
  TData = Awaited<ReturnType<typeof getLabelsSuggest>>,
  TError = void,
>(
  params?: GetLabelsSuggestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Suggest
 */

export function useGetLabelsSuggest<
  TData = Awaited<ReturnType<typeof getLabelsSuggest>>,
  TError = void,
>(
  params?: GetLabelsSuggestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLabelsSuggest>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLabelsSuggestQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update
 */
export const putLabelsId = (id: number, labelDto: LabelDto) => {
  return customInstance<LabelDto>({
    url: `/labels/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: labelDto,
  });
};

export const getPutLabelsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putLabelsId>>,
    TError,
    { id: number; data: LabelDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putLabelsId>>,
  TError,
  { id: number; data: LabelDto },
  TContext
> => {
  const mutationKey = ["putLabelsId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putLabelsId>>,
    { id: number; data: LabelDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putLabelsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutLabelsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putLabelsId>>
>;
export type PutLabelsIdMutationBody = LabelDto;
export type PutLabelsIdMutationError = void;

/**
 * @summary Update
 */
export const usePutLabelsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putLabelsId>>,
      TError,
      { id: number; data: LabelDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putLabelsId>>,
  TError,
  { id: number; data: LabelDto },
  TContext
> => {
  const mutationOptions = getPutLabelsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get By Id
 */
export const getLabelsId = (id: number, signal?: AbortSignal) => {
  return customInstance<LabelDto>({
    url: `/labels/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetLabelsIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/labels/${id}`] as const;
};

export const getGetLabelsIdQueryKey = (id?: number) => {
  return [`/labels/${id}`] as const;
};

export const getGetLabelsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabelsIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabelsId>>> = ({
    signal,
  }) => getLabelsId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getLabelsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabelsIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLabelsId>>
>;
export type GetLabelsIdInfiniteQueryError = void;

export function useGetLabelsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelsId>>,
          TError,
          Awaited<ReturnType<typeof getLabelsId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelsId>>,
          TError,
          Awaited<ReturnType<typeof getLabelsId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetLabelsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getLabelsId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getLabelsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLabelsIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetLabelsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabelsId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabelsId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabelsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabelsId>>> = ({
    signal,
  }) => getLabelsId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLabelsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabelsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLabelsId>>
>;
export type GetLabelsIdQueryError = void;

export function useGetLabelsId<
  TData = Awaited<ReturnType<typeof getLabelsId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabelsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelsId>>,
          TError,
          Awaited<ReturnType<typeof getLabelsId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsId<
  TData = Awaited<ReturnType<typeof getLabelsId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabelsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLabelsId>>,
          TError,
          Awaited<ReturnType<typeof getLabelsId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLabelsId<
  TData = Awaited<ReturnType<typeof getLabelsId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabelsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetLabelsId<
  TData = Awaited<ReturnType<typeof getLabelsId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLabelsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLabelsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteLabelsId = (id: number) => {
  return customInstance<boolean>({ url: `/labels/${id}`, method: "DELETE" });
};

export const getDeleteLabelsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLabelsId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLabelsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteLabelsId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLabelsId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLabelsId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLabelsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLabelsId>>
>;

export type DeleteLabelsIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteLabelsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteLabelsId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLabelsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteLabelsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
